export const CLIPS_TYPE = 'clips';
export const VOICEOVER_TYPE = 'voiceover';

export const MEDIA_TYPES = Object.freeze({
    [CLIPS_TYPE]: 'subtitles.editor.tags.clips',
    [VOICEOVER_TYPE]: 'voice_over.editor.title',
});